export interface CommercialOffer {
  id: string;
  name: string;
  logoUrl: string;
  clientId: string;
  bgModelId: string;
  view3dUrl: string;
  version: number;
  lastUpdate: Date;
  to: string;
  re: string;
  commercialOfferVersions: CommercialOfferVersion[];  //versions of the offer
  offerGroups?: OfferGroup[];
  comments?: Comment[];
  offerres?: Offeree[];
}

export interface CommercialOfferVersion {
  offerres: Offeree[];
  offerGroups: OfferGroup[];
  notes?: string;
  comments?: Comment[];
  version: string;
  lastUpdate: Date;
}

export interface Offeree {
  id: string;
  email: string;
  status: OffereeStatus;
  lastVisited: Date;
}

export enum OffereeStatus {
  DELIVERED = 'DELIVERED',
  READ = 'READ',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}

export enum OfferStatusSummary {
  ACCEPTED = 'ACCEPTED',
  REJECTED_PARTIAL = 'REJECTED_PARTIAL',
  READ = 'READ',
  DELIVERED = 'DELIVERED',
  NOT_SENT = 'NOT_SENT'
}

export interface OfferGroup {
  name: string;
  groupedSubOfferGroups: GroupedSubOfferGroup[]; //materials, custom, etc.
}

export interface GroupedSubOfferGroup {
  name: string;
  subOfferGroups: SubOfferGroup[];
}

export interface SubOfferGroup {
  name: string;
  offerItems: OfferItem[];
}

export interface OfferItem {
  designation: string | null;
  description: string;
  quantity: string;
  quantityDescription?: string;
  unitPrice: number;
  totalPrice: number; // Changed from 'total' to match API
  type: OfferItemType;
  priceSource: OfferPriceSource;
  sourceReference?: string | null
}

export enum OfferPriceSource {
  NotSet = 'NotSet',
  Manual = 'MANUAL',
  PriceCatalog = 'PRICE_CATALOG',
  AIExtracted = 'AIExtracted'
}

export enum OfferItemType {
  BOM = 'Bom',
  CUSTOMER = 'Customer'
}

export enum DefaultTableType {
  MATERIALS = 'Materials',
  CUSTOM = 'Custom'
}

export interface Comment {
  id: string;
  userId: string;
  text: string;
  date: Date;
}

export interface CommercialOfferOffereeRespond {
  id: string;
  title: string;
  logoUrl: string;
  clientId: string;
  bgModelId: string;
  view3dUrl: string;
  offerGroups: OfferGroup[];
  notes: string;
  comments: Comment[];
  to: string;
  re: string;
}

// Commercial Offer Preview interfaces for loadPreviews method
export interface CommercialOfferPreview {
  id: string;
  bgModelId: string;
  name: string;
  status: string;
  lastUpdate: string;
}

export interface CommercialOfferPreviewsResponse {
  commercialOfferPreviews: CommercialOfferPreview[];
}

// AI Assistant - Process Offer Items interfaces
export interface ProcessOfferItemsRequest {
  userMessage: string;
  offerGroups: OfferGroup[];
}

export interface ProcessOfferItemsResponse {
  message: string;
  offerGroups: OfferGroup[];
}
